import { Component } from '@angular/core'
import { appConfig } from '@configuration/app-config'
import { MetricService } from '@service/metric.service';

@Component({
  selector: 'app-benefits',
  templateUrl: './benefits.component.html',
  styleUrls: ['./benefits.component.scss'],
})
export class BenefitsComponent {

  public benefits = []

  constructor(
    private metricService: MetricService,
  ) {
  }

  async ngOnInit(): Promise<void> {
    await this.fetchMetrics();
  }

  private async fetchMetrics(): Promise<void> {
    try {
      const metrics = await this.metricService.getMetrics();

      this.populateSocialMediaNumbers(metrics);

    } catch (error) {
      console.error("failed to fetch metrics:", error);
      this.populateSocialMediaNumbers(null);
    }
  }

  private populateSocialMediaNumbers(metrics: any): void {
    this.benefits = [
      {
        id: 1,
        content_desktop: `Über ${metrics?.members ?? appConfig.members} Mitglieder im Online-Portal`,
        content_mobile: `${metrics?.members ?? appConfig.members}<br>Mitglieder`,
        image: '/img/logo.png'
      },
      {
        id: 2,
        content_desktop: `Über ${metrics?.members_facebook ?? appConfig.members_facebook} Mitglieder auf Facebook`,
        content_mobile: `${metrics?.members_facebook ?? appConfig.members_facebook}<br>Mitglieder`,
        icon: 'fab fa-facebook-square',
        link: 'https://www.facebook.com/ZimmererTreffpunkt/',
      },
      {
        id: 3,
        content_desktop: `Über ${metrics?.members_instagram ?? appConfig.members_instagram} Mitglieder auf Instagram`,
        content_mobile: `${metrics?.members_instagram ?? appConfig.members_instagram}<br>Mitglieder`,
        icon: 'fab fa-instagram',
        link: 'https://www.instagram.com/zimmerertreffpunkt/',
      },
    ];
  }

  public openLink(benefit) {
    if (typeof benefit.link != "undefined")
      window.open(benefit.link, "_blank")
  }

}
